import { render } from "./select.vue?vue&type=template&id=1f77c9b6"
import script from "./select.js?vue&type=script&lang=js"
export * from "./select.js?vue&type=script&lang=js"

import "./select.vue?vue&type=style&index=0&id=1f77c9b6&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__